import { InjectionToken } from '@angular/core';
import { AgentConfigOptions } from '@elastic/apm-rum';
export const ELASTIC_APM_TOKEN = new InjectionToken<AgentConfigOptions>('elasticApmConfig');
